import get from 'lodash/get';

export const FETCH_PARTNER = 'FETCH_PARTNER';
export const ALEXA_LINK_SUCCESS = 'ALEXA_LINK_SUCCESS';
export const ALEXA_LINK_FAIL = 'ALEXA_LINK_FAIL';
export const ALEXA_CHECK_STATUS = 'ALEXA_CHECK_STATUS';
export const ALEXA_GET_URLS = 'ALEXA_GET_URLS';
export const LINK_SONOS = 'LINK_SONOS';

export function fetchPartnersEffect(id) {
  const transform = (resp) => ({
    content: { ...resp },
  });

  return {
    type: FETCH_PARTNER,
    api: {
      endpoint: ['getPartners', 'getPartner'],
      args: [id],
      isWACBeta: true,
      transform,
    },
    meta: {
      contentId: id,
    },
  };
}

export function handleAlexaFailure() {
  return {
    type: ALEXA_LINK_FAIL,
  };
}

export function handleAlexaSuccess(authorizationCode) {
  return {
    type: ALEXA_LINK_SUCCESS,
    api: {
      endpoint: ['getPartners', 'linkAlexa'],
      args: [authorizationCode],
      isWACBeta: true,
    },
  };
}

export function getAlexaUrls() {
  return (dispatch, getState) => {
    const serial = get(getState(), 'app.tuneInUserSerial');

    return dispatch({
      type: ALEXA_GET_URLS,
      api: {
        endpoint: ['getPartners', 'getAlexaUrl'],
        args: [serial],
        isWACBeta: true,
      },
    });
  };
}

export function checkAlexaLinkStatus() {
  return {
    type: ALEXA_CHECK_STATUS,
    api: {
      endpoint: ['getPartners', 'getAlexaStatus'],
      isWACBeta: true,
    },
  };
}

// linkSonos action dispatches a request which tells the sonos device that it can complete partner pairing
export function linkSonos(authCode, state) {
  return {
    type: LINK_SONOS,
    api: {
      endpoint: ['getPartners', 'linkSonos'],
      args: [{ authCode, state }],
      isWACBeta: true,
    },
  };
}
